import { ListingType } from '@domain-group/fe-allhomes-library/lib/node';
export var pathParametersToListingType = slug => {
  var _Object$values$find;
  if (slug === 'sold') {
    return 'SALES_RESIDENTIAL';
  }
  return ((_Object$values$find = Object.values(ListingType).find(listingType => listingType.urlContext === slug)) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.name) || 'SALES_RESIDENTIAL';
};